export enum TooltipType {
  Default = 'default',
  Primary = 'primary',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Plain = 'plain',
}

export enum TooltipTrigger {
  Hover = 'hover',
  Click = 'click',
  Focus = 'focus',
  Manual = 'manual',
}
